export default {
  data() {
    return {
      htmlContainer: [],
      tooltipXPos: 0,
      tooltipYPos: 0,
      tooltipIsVisible: false
    }
  },
  methods: {
    displayNewTooltip(content) {
      this.tooltipIsVisible = true;
      this.htmlContainer.push(content);
    },
    hideTooltip() {
      this.tooltipIsVisible = false;
      this.htmlContainer = [];
    },
    setTooltipXPos(elementWidth) {
      this.tooltipXPos = elementWidth + 20;
    },
    setTooltipMousePos(event) {
      this.tooltipXPos = event.pageX;
      this.tooltipYPos = event.pageY;
    }
  }
}